export const broadcast_list = [
    { video_type: '', category_description: 'Matches' ,keep_tab: true},
    { video_type: 'OTHERS', category_description: 'Daywise Streaming' ,keep_tab: true},
    { video_type: 'INTERVIEW', category_description: 'Interviews' ,keep_tab: false},
    { video_type: 'OPENINGCEREMONY', category_description: 'Opening Ceremony' ,keep_tab: false},
    { video_type: 'AWARDCEREMONY', category_description: 'Award Ceremony' ,keep_tab: false},
    { video_type: 'CLOSINGCEREMONY', category_description: 'Draws' ,keep_tab: true},

  ]

  export const broadcastParticipantOptions =
  [
    { id: 'all', title: 'All' , status:'' },
    { id: 'live', title: 'Live', status:'L' },
    { id: 'streamed', title: 'Streamed', status:'S' }
  ]